import type { Item } from '../types';

// Import the magic items JSON from spellcards.app - Vite will bundle this at build time
// To update items: run `npm run scrape-spellcards-items`
import spellcardsItems from '../../public/spellcards-items.json';

// Export the items array with proper typing
export const items: Item[] = spellcardsItems as Item[];
